import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/styles';
import { Grid } from '@material-ui/core';
import { Carousel } from 'react-responsive-carousel';

import { useStyles } from './styles.js';
import CarouselStyles from './CarouselStyles';

class LeaderboardTabs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      event: props.event,
    };
  }

  componentDidMount() {}

  componentWillUnmount() {}

  render() {
    const { className, classes, history } = this.props;

    return (
      <>
        <Carousel
          dynamicHeight={false}
          infiniteLoop={false}
          autoPlay={false}
          className={classes.sliderConatiner}
          showIndicators={false}
          showThumbs={false}
          swipeable={true}
          emulateTouch={true}
          showStatus={false}
          onChange={() => this.props.onSliderChange()}
          selectedItem={this.props.selectedItem}
        >
          {this.props.event_settings.map((setting, index) => {
            return (
              <li
                id={`sliderList-${index}`}
                style={{
                  borderColor: this.props.buttonTextColor,
                  color: this.props.buttonTextColor,
                  fontSize: '1rem',
                  padding: '15px',
                }}
                className={classes.activeTab}
                onClick={() => this.props.onTabClick(setting)}
              >
                {setting.name}
              </li>
            );
          })}
        </Carousel>

        <CarouselStyles buttonTextColor={this.props.buttonTextColor} />
      </>
    );
  }
}

LeaderboardTabs.propTypes = {
  className: PropTypes.string,
};

export default withStyles(useStyles)(LeaderboardTabs);
